import React from 'react';

const PeopleTagIcon = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.00016 7.65617C6.11611 7.65617 5.26826 7.30498 4.64314 6.67986C4.01802 6.05474 3.66683 5.20689 3.66683 4.32283C3.66683 3.43878 4.01802 2.59093 4.64314 1.96581C5.26826 1.34069 6.11611 0.989502 7.00016 0.989502C7.88422 0.989502 8.73206 1.34069 9.35718 1.96581C9.98231 2.59093 10.3335 3.43878 10.3335 4.32283C10.3335 5.20689 9.98231 6.05474 9.35718 6.67986C8.73206 7.30498 7.88422 7.65617 7.00016 7.65617ZM7.00016 10.1562C9.65516 10.1562 12.0377 10.632 13.6668 12.7087V14.3228H0.333496V12.7087C1.96266 10.6312 4.34516 10.1562 7.00016 10.1562Z" fill="#44A5E0" />
  </svg>
);

export default PeopleTagIcon;
